/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cta_LedeInputs */

const en_faq_cta_lede = /** @type {(inputs: Faq_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring us a task, a question or an idea you’d like to explore.`)
};

const lv_faq_cta_lede = /** @type {(inputs: Faq_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atnesiet mums uzdevumu, jautājumu vai ideju, ko gribētos izpētīt.`)
};

/**
* | output |
* | --- |
* | "Bring us a task, a question or an idea you’d like to explore." |
*
* @param {Faq_Cta_LedeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_cta_lede = /** @type {((inputs?: Faq_Cta_LedeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cta_LedeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_cta_lede(inputs)
	return en_faq_cta_lede(inputs)
});